import { AbstractControl, FormBuilder, Validators } from '@angular/forms';

export function passwordMatchValidator(group: AbstractControl) {
  const p = group.get('newPassword')?.value;
  const c = group.get('confirmPassword')?.value;
  return p && c && p !== c ? { passwordMismatch: true } : null;
}

export function buildLoginForm(fb: FormBuilder) {
  return fb.group({
    email: ['', [Validators.required]],
    password: ['', [Validators.required]],
  });
}

export function buildResetForm(fb: FormBuilder) {
  return fb.group(
    {
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]],
    },
    { validators: [passwordMatchValidator], updateOn: 'blur' },
  );
}
